import { BudgetExpenseOrIncome } from 'business/constants';
import { ResourceBudgetProposalAssociationT } from 'routes/BudgetModule/config/types';

export const buildOrphanInscriptionPayload = (
    expenseIncome: BudgetExpenseOrIncome,
    budgetProposalResource: ResourceBudgetProposalAssociationT,
    operationSoftwareId?: string,
    isOperationDraft: boolean = false,
): {
    budgetProposalId: number;
    expenseIncome: BudgetExpenseOrIncome;
    resourceSoftwareId: string;
    operationSoftwareId?: string | null;
    draftOperationSoftwareId?: string | null;
} => ({
    budgetProposalId: budgetProposalResource.budgetProposal.id,
    expenseIncome,
    resourceSoftwareId:
        budgetProposalResource.resource?.resourceSoftwareId || '',
    operationSoftwareId: isOperationDraft ? null : operationSoftwareId,
    draftOperationSoftwareId: isOperationDraft ? operationSoftwareId : null,
});
